function DevicePoolBar({ label, used, total, isDarkMode }) {
	const percentage = total > 0 ? Math.min((used / total) * 100, 100) : 0
	const isNearLimit = percentage >= 80
	const isOverLimit = used > total

	return (
		<div>
			<div className="flex items-center justify-between mb-1">
				<span
					className={`text-xs font-medium ${
						isDarkMode ? 'text-gray-300' : 'text-gray-700'
					}`}
				>
					{label}
				</span>
				<span
					className={`text-xs font-medium ${
						isOverLimit
							? 'text-red-500'
							: isNearLimit
							? isDarkMode
								? 'text-orange-400'
								: 'text-orange-600'
							: isDarkMode
							? 'text-gray-400'
							: 'text-gray-500'
					}`}
				>
					{used} / {total}
				</span>
			</div>
			<div
				className={`w-full h-2 rounded-full ${
					isDarkMode ? 'bg-gray-700' : 'bg-gray-200'
				}`}
			>
				<div
					className={`h-2 rounded-full transition-all ${
						isOverLimit
							? 'bg-red-500'
							: isNearLimit
							? 'bg-orange-500'
							: 'bg-blue-500'
					}`}
					style={{ width: `${percentage}%` }}
				/>
			</div>
		</div>
	)
}

export default DevicePoolBar
